import { Box, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";

export const MessagePanelContainer = styled(Box)`
  height: 100%;
  width: 100%;
`;

export const MessagePanelBox = styled(Box)`
  padding: 5px;
`;

export const MessagePanelMenuBar = styled(Box)`
  background-color: ${({ theme }) => theme.messagePanelBackground};
  border-radius: 10px;
  padding-top: 1px;
`;

export const MenuBarTabsContainer = styled(Tabs)`
  align-items: center;
`;

export const ChatListPanelHeaderContainer = styled(Box)`
  display: flex;
  margin: 10px 0 10px 12px;
  position: inherit;
`;

export const ChatListTabItem = styled(Tab)`
  min-height: 0;
  min-width: 70px;
  padding: 0;
  font-weight: 400;
  font-size: 0.65rem;
  margin-bottom: 6px;
`;
